import { CanvasRenderingContext2DWrapper } from "./util/canvas";
import { ImageCache } from "./imageCache";
import { ImageChunk, Point, Rectangle } from "./util";

export class View {
  private renderer: CanvasRenderingContext2DWrapper;
  private imageCache: ImageCache;

  constructor(context: CanvasRenderingContext2D, imageCache: ImageCache) {
    this.renderer = new CanvasRenderingContext2DWrapper(context);
    this.imageCache = imageCache;
  }

  /**
   * 表示内容をスライドさせる
   * @param dragDiff
   */
  /*
	public slideTo(dragDiff: Point) {
		console.error('まだ実装されていない');
	}
	*/

  /**
   * スライドを完了させる
   * @param dragDiff
   */
  /*
	public fixSlideState(dragDiff: Point) {
		console.error('まだ実装されていない');
	}
	*/

  /**
   * 表示を拡大する
   * @param deltaMagnificationRate
   * @param pointer
   */
  public zoom(
    deltaMagnificationRate: number,
    pointer: Point,
    canvasRect: Rectangle,
  ) {
    console.error("まだ実装されていない");
  }

  /**
   * 画像を逐次表示する
   * @param images 表示する画像情報の一覧
   */
  public showImages(imageChunks: ImageChunk[]): void {
    imageChunks.forEach((imageChunk) => {
      this.drawImageChunk(imageChunk).then((value) => console.log(value));
    });
  }

  /**
   * 指定された画像をキャンバスへレンダリングする
   *
   * @description
   *      指定された画像はキャッシュからの取得を試みる。
   *
   * @param imageChunk 処理対象の画像情報
   */
  public drawImageChunk(imageChunk: ImageChunk): Promise<string> {
    console.log(`drawImageChunk(imageChunk:${imageChunk.url})`);
    return new Promise<string>((resolve) => {
      let image = this.imageCache.get(imageChunk.url);

      // キャッシュに存在しない画像
      if (image == null) {
        image = new Image();
        image.onload = () => {
          this.renderer.drawImage(
            image as HTMLImageElement,
            imageChunk.srcRect,
            imageChunk.dstRect,
          );
          const msg = `image1: ${imageChunk} `;
          resolve(msg);
        };
        image.src = imageChunk.url;
        this.imageCache.set(imageChunk.url, image); //19.11.19
      }
      // キャッシュされているが、まだ読み込みがおわっていない画像
      else if (!image.complete) {
        image.onload = () => {
          this.renderer.drawImage(
            image as HTMLImageElement,
            imageChunk.srcRect,
            imageChunk.dstRect,
          );
          const msg = `image2: ${imageChunk} `;
          resolve(msg);
        };
      }
      // すでに読み込まれている画像
      else {
        this.renderer.drawImage(
          image as HTMLImageElement,
          imageChunk.srcRect,
          imageChunk.dstRect,
        );
        const msg = `キャッシュから: ${imageChunk} `;
        resolve(msg);
      }
    });
  }

  public clearScreen(canvasRect: Rectangle): void {
    //let	x= canvasRect.left;
    //let	y= canvasRect.top;
    //let	w= canvasRect.width;
    //let	h= canvasRect.height;
    this.renderer.clear(canvasRect);
  }
}
